export default (id) => ({
  open: false,
  id: id,
  show() {
    this.open = true;
    if (window.Livewire) {
      window.Livewire.emit("dropdownMenuOpened", this.id);
    }
  },
  hide() {
    this.open = false;
    if (window.Livewire) {
      window.Livewire.emit("dropdownMenuClosed", this.id);
    }
  },
  trigger: {
    ["@open-dropdown-menu.window"](e) {
      if (e.detail == this.id) {
        this.show();
      } else {
        this.hide();
      }
    },
    ["@close-dropdown-menu.window"](e) {
      if (e.detail == this.id) {
        this.hide();
      }
    },
  },
});
